import { EVENT_STATUS } from '@hedepy/common/enums/EVENT'

import { useAuthenticatedUser } from '@/legacy-src/hooks/useAuthenticatedUser'
import { useAppSelector } from '@/legacy-src/store/hooks'

import { reservedEventsSelector } from '../store/selectors/UserSelectors'

const useUserHasCompletedSession = (therapistId: number) => {
  const { user } = useAuthenticatedUser()
  const { notReservedEvents } = useAppSelector((state) =>
    reservedEventsSelector(state, {
      userType: user.type,
    }),
  )
  return notReservedEvents.some((item) => item.status === EVENT_STATUS.COMPLETED && item.therapistId === therapistId)
}

export default useUserHasCompletedSession
